function toggleTimelineItem(clickedItem) {
  const isAlreadyOpen = clickedItem.classList.contains("open");

  // Cierra todos los items abiertos
  document.querySelectorAll(".timeline-item").forEach((item) => {
    item.classList.remove("open");
  });

  if (!isAlreadyOpen) {
    clickedItem.classList.add("open");

    // Determina en qué lado está el título (no vacío)
    const leftSide = clickedItem.querySelector(
      ".timeline-side-left:not(.timeline-side-empty)",
    );
    const inner = clickedItem.querySelector(".timeline-detail-inner");
    const p = clickedItem.querySelector(".timeline-detail-inner p");

    if (inner) {
      if (leftSide) {
        // Título a la izquierda → borde a la izquierda (el panel abre hacia la derecha)
        inner.style.borderLeft = "2px solid var(--gold)";
        inner.style.borderRight = "none";
        inner.style.borderRadius = "0 3px 3px 0";
        p.style.textAlign = "left";
      } else {
        // Título a la derecha → borde a la derecha (el panel abre hacia la izquierda)
        inner.style.borderLeft = "none";
        inner.style.borderRight = "2px solid var(--gold)";
        inner.style.borderRadius = "3px 0 0 3px";
        p.style.textAlign = "right";
      }
    }
  }
}
